import React, { Component } from "react";

import { HomeSlider, HomeTitle } from "../../Components/UI/UI";

import { getWeather } from "../../Utility/Utility";

import MenuHome from "../../Components/Menu/MenuHome";
import Footer from "../../Components/Footer/Footer";

import "./ContactUs.css";

class ContactUs extends Component {
  state = {
    telAvivWeather: 0,
    waterTemp: 0,
    jerusalemWeather: 0,
  };

  componentDidMount() {
    getWeather((Weather) => {
      // console.log("Weather", Weather);
      this.setState({
        telAvivWeather: Weather.telAvivWeather,
        waterTemp: Weather.water_temp,
        jerusalemWeather: Weather.jerusalemWeather,
      });
    });
  }

  render() {
    return (
      <div className="page align-left page-TermsOfUse">
        <MenuHome />
        <HomeSlider
          waterTemp={this.state.waterTemp}
          telAvivWeather={this.state.telAvivWeather}
          jerusalemWeather={this.state.jerusalemWeather}
        />

        <div className="container">
          <HomeTitle>Contact Us</HomeTitle>
          <div className="ac-details">
            {/* <p>
              <strong>New York – North East Region US Tel</strong>:
              1-646-779-6764 ChadM@goisrael.gov.il
              <br />
              <strong>Los Angeles – Western Region US Tel</strong>:
              1-323-658-7463 Director-LA@goisrael.gov.il
              <br />
              <strong>Atlanta – Southern Region US Tel</strong>: 1-404-541-2770
              Director-Atlanta@goisrael.gov.il
              <br />
              <strong>Chicago – Midwest Region US Tel</strong>: 1-312-803-7078
              JillD@goisrael.gov.il
              <br />
              <strong>Canada - Tel</strong>: 1-312-803-7080
              igtocanada@goisrael.gov.il
            </p> */}
            <h3>North America</h3>
            <table>
              <tr>
                <th>Country</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
              <tr>
                <td>North East Region U.S.</td>
                <td>ChadM@goisrael.gov.il</td>
                <td>1-646-779-6764</td>
              </tr>
              <tr>
                <td>Western Region U.S.</td>
                <td>Director-LA@goisrael.gov.il</td>
                <td>1-323-658-7463</td>
              </tr>
              <tr>
                <td>Southern Region U.S.</td>
                <td>Director-Atlanta@goisrael.gov.il</td>
                <td>1-404-541-2770</td>
              </tr>
              <tr>
                <td>Midwest Region U.S.</td>
                <td>JillD@goisrael.gov.il</td>
                <td>1-312-803-7080</td>
              </tr>
              <tr>
                <td>Canada</td>
                <td>Marketing-canada@goisrael.gov.il</td>
                <td>1-312-803-7080</td>
              </tr>
            </table>
            <h3>Europe</h3>
            <table>
              <tr>
                <th>Country</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
              <tr>
                <td>France</td>
                <td>LaurelineM@goisrael.gov.il</td>
                <td>33-142-618590</td>
              </tr>
              <tr>
                <td>Germany</td>
                <td>Director-de@goisrael.gov.il</td>
                <td>49-30-20399725</td>
              </tr>
              <tr>
                <td>Holland</td>
                <td>Director-nl@goisrael.gov.il</td>
                <td>31-68-750-5375</td>
              </tr>
              <tr>
                <td>Italy</td>
                <td>Director-it@goisrael.gov.il</td>
                <td>39-2-84086005</td>
              </tr>
              <tr>
                <td>Poland</td>
                <td>Zohar@goisrael.gov.il</td>
                <td>48226307972</td>
              </tr>
              <tr>
                <td>Russia</td>
                <td>Director-ru@goisrael.gov.il</td>
                <td>79-855599264</td>
              </tr>
              <tr>
                <td>Scandinavia</td>
                <td>Marketing-se@goisrael.gov.</td>
                <td>31-68-750-5375</td>
              </tr>
              <tr>
                <td>Spain and Portugal</td>
                <td>Director-es@goisrael.gov.il</td>
                <td>34-915-943211</td>
              </tr>
              <tr>
                <td>Ukraine</td>
                <td>AnnaS@goisrael.gov.il</td>
                <td>38-0999467940</td>
              </tr>
              <tr>
                <td>United Kingdom</td>
                <td>SharonE@goisrael.gov.il</td>
                <td>44-207-2991100</td>
              </tr>
            </table>
            <h3>Latin America</h3>
            <table>
              <tr>
                <th>Country</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
              <tr>
                <td>Brazil</td>
                <td>CarolinaD@goisrael.gov.il</td>
                <td>55-11-3034-6423</td>
              </tr>
            </table>
            <h3>Asia</h3>
            <table>
              <tr>
                <th>Country</th>
                <th>Email</th>
                <th>Phone</th>
              </tr>
              <tr>
                <td>China</td>
                <td>Director-sh@goisrael.gov.il</td>
                <td>86-106-46-43165</td>
              </tr>
              <tr>
                <td>India</td>
                <td>Director-India@goisrael.gov.il</td>
                <td>91-22-61370701</td>
              </tr>
              <tr>
                <td>Philippines</td>
                <td>Marketing-ph@goisrael.gov.il</td>
                <td>63-2-883-9550</td>
              </tr>
              <tr>
                <td>Republic of Korea</td>
                <td>JulesJ@tourism.gov.il</td>
                <td>82-273-80882</td>
              </tr>
            </table>
          </div>
        </div>
        <Footer />
      </div>
    );
  }
}

export default ContactUs;



// WEBPACK FOOTER //
// ./src/Pages/ContactUs/ContactUs.js